import React, { Component } from 'react';
import classNames from 'classnames/bind';
import axios from 'axios';

import {
  DataBlocks,
  Button,
  I18n,
} from 'components';

import NewAdressRequest from './NewAdressRequest';
import NewAddressPopup from './NewAddressPopup';
import styles from './styles.pcss';
import { getObjectFromHref } from '../../../Internet/utils/getObjectFromHref';

const cx = classNames.bind(styles);

export default class HomeAddress extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    axios.get('/api/profile/homeinternet/address/')
      .then(({ data }) => this.setState(data))
      .then(() => {
        const { move } = getObjectFromHref(window.location.href);

        if (move) {
          this.setPopupVisibility();
        }
      })
      .catch((error) => error);
  }

  setPopupVisibility = () => {
    this.setState((prevState) => ({
      isNewAddressPopupOpened: !prevState.isNewAddressPopupOpened,
    }));
  }

  toggleNewAddressPopupPopup = () => {
    this.setPopupVisibility();
  }

  render() {
    const {
      address,
      ticket,
      isNewAddressPopupOpened,
    } = this.state;

    return (
      <>
        <DataBlocks.Block
          title={<I18n path="internet.address.blockTitle" />}
          isLoading={!address}
        >
          <DataBlocks.Table>
            <DataBlocks.TableRow>
              <DataBlocks.TableCell className={cx('addressCell')}>
                {address}
              </DataBlocks.TableCell>
              <DataBlocks.TableCell className={cx('buttonCell')}>
                {!ticket && (
                  <Button
                    className="default"
                    onClick={this.toggleNewAddressPopupPopup}
                  >
                    <I18n path="internet.address.changeAdress" />
                  </Button>
                )}
              </DataBlocks.TableCell>
            </DataBlocks.TableRow>

            {ticket && (
              <DataBlocks.TableRow>
                <DataBlocks.TableCell colSpan="2">
                  <NewAdressRequest {...ticket} />
                </DataBlocks.TableCell>
              </DataBlocks.TableRow>
            )}
          </DataBlocks.Table>
        </DataBlocks.Block>

        {isNewAddressPopupOpened && (
          <NewAddressPopup
            onClose={this.toggleNewAddressPopupPopup}
          />
        )}
      </>
    );
  }
}
